import { render } from "./time.vue?vue&type=template&id=764f1ec0"
import script from "./time.vue?vue&type=script&lang=js"
export * from "./time.vue?vue&type=script&lang=js"

import "./time.vue?vue&type=style&index=0&id=764f1ec0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__